import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { GatsbyImage } from 'gatsby-plugin-image';
import DefaultHero from './DefaultHero';
import Content from './Content';
import { Icons, News } from 'components/Intro';
import { isRequestedFrom, useLang } from 'utils/localisation';
import { getImagesWithArtDirection } from 'utils/images';
import { isSsr } from 'define';
import { arabicRegion } from 'define/locale';

import * as styles from './Intro.module.scss';

export default function Intro({
  title,
  subtitle,
  button,
  video,
  icons,
  certificateIDs,
  imgAlt = '',
  contentMod = 'default',
  gatsbyImage,
  gatsbyImageList,
}) {
  const lang = useLang();
  const showNews = lang === 'en' || lang === 'uk' || lang === 'kz' || lang === 'pl';
  const isDesktop = !isSsr && window.innerWidth > 1024;

  const [region, setRegion] = useState(lang !== 'en' ? 'default' : null);

  useEffect(() => {
    if (!region && gatsbyImageList) {
      if (isRequestedFrom(arabicRegion)) {
        setRegion('mena');
        return;
      }
      setRegion('default');
    }
  }, [gatsbyImageList, region]);

  const preparedImageFromList = region
    ? gatsbyImageList?.find(item => item?.region === region)
    : null;

  const getPreparedImages = () => {
    if (preparedImageFromList) {
      return getImagesWithArtDirection(preparedImageFromList);
    }
    if (gatsbyImage) {
      return getImagesWithArtDirection(gatsbyImage);
    }
  };

  const preparedImages = getPreparedImages();

  const preparedVideoFromList = region
    ? gatsbyImageList?.find(item => item?.region === region)?.video
    : null;
  const preparedVideo = preparedVideoFromList ?? video;

  return (
    <section id="intro" className={styles.introWrapper}>
      <div className={styles.intro}>
        {preparedImages && (
          <GatsbyImage
            alt={imgAlt}
            image={preparedImages}
            className={styles.picture}
            imgClassName={styles.pictureImage}
            loading="eager"
          />
        )}
        {lang !== 'ae' && preparedVideo && (
          <DefaultHero video={preparedVideo} isDesktop={isDesktop} />
        )}
        <div className={cn(styles.content, styles[contentMod])}>
          <div className={styles.contentLayout}>
            <Content title={title} subtitle={subtitle} button={button} />
          </div>
          {(icons || certificateIDs) && (
            <Icons className={styles.mobileHidden} certificateIDs={certificateIDs} list={icons} />
          )}
        </div>
      </div>
      {showNews && <News className={styles.news} />}
    </section>
  );
}
